try {
// morning bands: 1-2 large edge blobs per band; the first sits just under the title, a second for long bands
(function(){
  // time-of-day tone: data-tod on each route (night 21-05, morning 05-11, midday 11-16, evening 16-21), refreshed
  // every minute; ?lys_tod=night|morning|midday|evening forces one. The hero keeps its own copy of this schedule.
  var q = (location.search.match(/[?&]lys_tod=(\w+)/) || [])[1];
  function phase(){ var h = new Date().getHours(); return (h >= 21 || h < 5) ? 'night' : (h < 11) ? 'morning' : (h < 16) ? 'midday' : 'evening'; }
  function setTod(){ var p = /^(night|morning|midday|evening)$/.test(q) ? q : phase(); [].forEach.call(document.querySelectorAll('.lys-route[data-route]'), function(m){ m.setAttribute('data-tod', p); }); }
  setTod(); setInterval(setTod, 60000);

  function seeded(str){                                                     // mulberry32 seeded from a string hash
    var a = 0; for (var i = 0; i < str.length; i++) a = (a * 31 + str.charCodeAt(i)) | 0;
    return function(){ a = (a + 0x6D2B79F5) | 0; var t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  function clamp(v, lo, hi){ return Math.min(hi, Math.max(lo, v)); }
  // edge blob: core on (or just off) the page edge, fades out by 85 % of its radius
  function blob(rx, ry, x, y, k, scale){
    rx = Math.round(rx * scale); ry = Math.round(ry * scale);
    function st(m, at){ return 'rgb(var(--c) / calc(var(--a) * ' + (k * m).toFixed(3) + ')) ' + at; }
    return 'radial-gradient(' + rx + 'px ' + ry + 'px at ' + x + 'px ' + y + 'px, ' +
      [st(1, '0%'), st(.7, '28%'), st(.3, '52%'), st(.08, '72%'), 'rgb(var(--c) / 0) 85%'].join(', ') + ')';
  }
  function layout(sec, idx){
    var r = sec.getBoundingClientRect(), W = r.width, h = r.height; if (!h) return;
    var bleed = -parseFloat(getComputedStyle(sec, '::before').top) || 120;
    // blob count: 1, or 2 once the band is over ~2.5 screens of section units
    var unit = Math.min(800, Math.max(600, 930 - .33 * W));
    var n = h < 1.2 * unit ? 1 : Math.min(6, Math.max(2, Math.round(h / unit)));
    var nE = Math.min(2, Math.ceil(n / 2));
    var scale = clamp(parseFloat(sec.getAttribute('data-blob-scale')) || 1, .5, 1);
    // title position decides the first blob's side (centred titles alternate per band)
    var t = sec.querySelector('h2'), tr = t ? t.getBoundingClientRect() : r;
    var tx = tr.left - r.left + tr.width / 2, ty = tr.top - r.top + tr.height / 2 + bleed;
    var left = Math.abs(tx - W / 2) < W * .08 ? idx % 2 === 0 : tx < W / 2;
    var rnd = seeded('E' + (sec.id || idx));
    function b(a, c){ return a + (c - a) * rnd(); }
    // first blob: centre under the title; capped so long bands get pale gaps, not bigger blobs
    var yEnd = bleed + h - Math.min(260, .22 * h);
    var ry1 = nE > 1 ? Math.min(.75 * (yEnd - ty), 620) : Math.max(.7 * h, 480);
    var y1 = ty + Math.min(260, Math.max(120, .3 * ry1));
    var step = nE > 1 ? (yEnd - y1) / (nE - 1) : 0;
    var L = [blob(Math.round(clamp(ry1 * b(1.4, 2.6), .8 * W, 1.3 * W)), Math.round(ry1), left ? 0 : Math.round(W), Math.round(y1), .47, scale)];
    // second blob: other edge, seeded random within ranges
    for (var j = 1; j < nE; j++){
      left = !left;
      var y = y1 + j * step + b(-.15, .15) * step;
      var x = left ? b(-.1, .04) * W : W * (1 - b(-.1, .04));
      var ry = Math.min(b(.6, .85) * step + 120, b(540, 660));
      L.push(blob(Math.round(clamp(ry * b(1, 2.4), .5 * W, 1.3 * W)), Math.round(ry), Math.round(x), Math.round(y), +b(.38, .47).toFixed(3), scale));
    }
    var blobLimit = sec.getAttribute('data-blob-count') === '1' ? 1 : L.length;
    sec.style.setProperty('--large-bg', L.slice(0, blobLimit).join(','));
  }
  // lay out every band now and whenever it resizes (route change, resize, opened details)
  [].forEach.call(document.querySelectorAll('.lys-route[data-route]'), function(m){
    [].forEach.call(m.querySelectorAll(':scope > section.band-morning'), function(s, i){
      layout(s, i);
      if (window.ResizeObserver) new ResizeObserver(function(){ layout(s, i); }).observe(s);
    });
  });
})();
} catch (e) { console.error("lys-v4 bands", e); }
